const DEFAULT_API_BASE = "https://api.werbeauto.ch";
const KNOWN_APP_SUBDOMAINS = ["admin", "advertiser", "demo", "idm", "api"];

const normalizeBaseUrl = (value) => {
  const normalized = typeof value === "string" ? value.trim() : "";
  return normalized ? normalized.replace(/\/$/, "") : "";
};

const deriveApiBaseFromHostname = (hostname, protocol) => {
  if (!hostname) {
    return "";
  }

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "";
  }

  const segments = hostname.split(".").filter(Boolean);
  if (!segments.length) {
    return "";
  }

  const baseSegments =
    KNOWN_APP_SUBDOMAINS.includes(segments[0]) && segments.length > 1 ? segments.slice(1) : segments;

  if (!baseSegments.length) {
    return "";
  }

  return `${protocol}//api.${baseSegments.join(".")}`;
};

const envBase = normalizeBaseUrl(process.env.REACT_APP_API_BASE);
const runtimeBase =
  typeof window !== "undefined"
    ? deriveApiBaseFromHostname(window.location.hostname, window.location.protocol)
    : "";
const rawBase = envBase || runtimeBase || DEFAULT_API_BASE;
const normalized = normalizeBaseUrl(rawBase);

export const API_BASE =
  normalized && normalized !== "/"
    ? normalized.endsWith("/")
      ? normalized.slice(0, -1)
      : normalized
    : "";

export const buildApiUrl = (path = "") => {
  if (!API_BASE) {
    return path;
  }

  if (!path) {
    return API_BASE;
  }

  return `${API_BASE}${path.startsWith("/") ? path : `/${path}`}`;
};
